import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./features/auth/LoginPage";
import { ProtectedRoute } from "./features/auth/ProtectedRoute";
import { SetupPage } from "./features/auth/SetupPage";
import { RegisterPage } from "./features/auth/RegisterPage";
import { AccettaInvitoPage } from "./features/auth/AccettaInvitoPage";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { InvitiPage } from "./features/admin/InvitiPage";
import { NotifichePage } from "./features/notifiche/NotifichePage";
import { RosaPage } from "./features/rosa/RosaPage";
import { TesoreriaPage } from "./features/tesoreria/TesoreriaPage";
import { RinnoviPage } from "./features/rinnovi/RinnoviPage";
import { MercatoPage } from "./features/mercato/MercatoPage";
import { FormazionePage } from "./features/formazione/FormazionePage";
import { CaricaVotiPage } from "./features/voti/CaricaVotiPage";
import { VotiGiornataPage } from "./features/voti/VotiGiornataPage";
import { CaricaProbabiliPage } from "./features/voti/CaricaProbabiliPage";
import { GiornataPage } from "./features/voti/GiornataPage";
import { RinviiPage } from "./features/voti/RinviiPage";
import { LegaPage } from "./features/lega/LegaPage";
import { GestioneCompetizioniPage } from "./features/lega/GestioneCompetizioniPage";
import { PartitaDetailPage } from "./features/partita/PartitaDetailPage";
import { TMImportPage } from "./features/admin/TMImportPage";
import { ConfigDiscordPage } from "./features/admin/ConfigDiscordPage";
import { ImportListonePage } from "./features/admin/ImportListonePage";
import { PrivacyPage } from "./features/privacy/PrivacyPage";
import { LeghePage } from "./features/leghe/LeghePage";
import { StagioniAdminPage } from "./features/admin/StagioniAdminPage";
import { AuditLogPage } from "./features/admin/AuditLogPage";
import { BackupAdminPage } from "./features/admin/BackupAdminPage";
import { RegolamentoEditorPage } from "./features/admin/RegolamentoEditorPage";
import { UsersAdminPage } from "./features/admin/UsersAdminPage";
import { GestionePage } from "./features/gestione/GestionePage";
import { GiocatoriPage } from "./features/giocatori/GiocatoriPage";
import { GiocatoreDetailPage } from "./features/giocatori/GiocatoreDetailPage";
import { ErrorBoundary } from "./features/common/ErrorBoundary";
import { OfflineBanner } from "./features/common/OfflineBanner";
import { RegolePage } from "./features/regole/RegolePage";
import { RosePage } from "./features/rose/RosePage";
import { StoricoPage } from "./features/storico/StoricoPage";
import { BudgetPage } from "./features/budget/BudgetPage";
import { AstaAdminPage } from "./features/admin/AstaAdminPage";
import { PrestitiPage } from "./features/prestiti/PrestitiPage";
import { GestioneScommessePage } from "./features/admin/GestioneScommessePage";
import { CentroScommessePage } from "./features/scommesse/CentroScommessePage";
import { GazzettaPage } from "./features/gazzetta/GazzettaPage";
import { ProfiloPage } from "./features/profilo/ProfiloPage";
import { IconeGiocatoriPage } from "./features/admin/IconeGiocatoriPage";
import { MonitorLeghePage } from "./features/admin/MonitorLeghePage";
import { SquadCupAdminPage } from "./features/admin/SquadCupAdminPage";
import { SquadCupPage } from "./features/squadcup/SquadCupPage";
import { SincronizzaLingua } from "./i18n/SincronizzaLingua";
import { AvvioLegaPreferita } from "./features/shell/AvvioLegaPreferita";
import { LandingPage } from "./features/landing/LandingPage";
import { useAuthStore } from "./lib/auth-store";
import { useLingua } from "./i18n";

/** La radice del sito: chi non e' entrato vede la presentazione, chi e'
 * entrato la Home della sua lega (la preferita o l'ultima usata). */
function Radice() {
  const entrato = useAuthStore((s) => !!s.accessToken);
  if (!entrato) return <LandingPage />;
  return (
    <ProtectedRoute>
      <DashboardPage />
    </ProtectedRoute>
  );
}

function App() {
  // al cambio lingua le pagine si rimontano (tr() di modulo, niente hook ovunque)
  const lingua = useLingua();
  return (
    <ErrorBoundary>
      <SincronizzaLingua />
      <AvvioLegaPreferita />
      <OfflineBanner />
      <Routes key={lingua}>
        {/* Pubbliche */}
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Protette */}
        {/* Andrea 2026-10-10: senza accesso la radice mostra la presentazione */}
        <Route path="/" element={<Radice />} />
        <Route path="/benvenuto" element={<LandingPage />} />
        <Route
          path="/accetta-invito"
          element={
            <ProtectedRoute>
              <AccettaInvitoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gestione"
          element={
            <ProtectedRoute>
              <GestionePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/giocatori"
          element={
            <ProtectedRoute>
              <GiocatoriPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/giocatori/:id"
          element={
            <ProtectedRoute>
              <GiocatoreDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/inviti"
          element={
            <ProtectedRoute>
              <InvitiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <UsersAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifiche"
          element={
            <ProtectedRoute>
              <NotifichePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rosa"
          element={
            <ProtectedRoute>
              <RosaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tesoreria"
          element={
            <ProtectedRoute>
              <TesoreriaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rinnovi"
          element={
            <ProtectedRoute>
              <RinnoviPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mercato"
          element={
            <ProtectedRoute>
              <MercatoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prestiti"
          element={
            <ProtectedRoute>
              <PrestitiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/formazione"
          element={
            <ProtectedRoute>
              <FormazionePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/giornata"
          element={
            <ProtectedRoute>
              <GiornataPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/carica-voti"
          element={
            <ProtectedRoute>
              <CaricaVotiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/voti-giornata"
          element={
            <ProtectedRoute>
              <VotiGiornataPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/probabili"
          element={
            <ProtectedRoute>
              <CaricaProbabiliPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/rinvii"
          element={
            <ProtectedRoute>
              <RinviiPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lega"
          element={
            <ProtectedRoute>
              <LegaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/competizioni"
          element={
            <ProtectedRoute>
              <GestioneCompetizioniPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partita/:partitaId"
          element={
            <ProtectedRoute>
              <PartitaDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tm-import"
          element={
            <ProtectedRoute>
              <TMImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/config-discord"
          element={
            <ProtectedRoute>
              <ConfigDiscordPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/import-listone"
          element={
            <ProtectedRoute>
              <ImportListonePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leghe"
          element={
            <ProtectedRoute>
              <LeghePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/privacy"
          element={
            <ProtectedRoute>
              <PrivacyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/stagioni"
          element={
            <ProtectedRoute>
              <StagioniAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/audit"
          element={
            <ProtectedRoute>
              <AuditLogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/backup"
          element={
            <ProtectedRoute>
              <BackupAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/regolamento"
          element={
            <ProtectedRoute>
              <RegolamentoEditorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/regole"
          element={
            <ProtectedRoute>
              <RegolePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rose"
          element={
            <ProtectedRoute>
              <RosePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/storico"
          element={
            <ProtectedRoute>
              <StoricoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/budget"
          element={
            <ProtectedRoute>
              <BudgetPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/asta"
          element={
            <ProtectedRoute>
              <AstaAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/scommesse"
          element={
            <ProtectedRoute>
              <GestioneScommessePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scommesse"
          element={
            <ProtectedRoute>
              <CentroScommessePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gazzetta"
          element={
            <ProtectedRoute>
              <GazzettaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profilo"
          element={
            <ProtectedRoute>
              <ProfiloPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/leghe-monitor"
          element={
            <ProtectedRoute>
              <MonitorLeghePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/icone-giocatori"
          element={
            <ProtectedRoute>
              <IconeGiocatoriPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/squadcup"
          element={
            <ProtectedRoute>
              <SquadCupAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/squadcup"
          element={
            <ProtectedRoute>
              <SquadCupPage />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
